<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" destroy-on-close>
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="时间树" prop="treeTimeId" >
        <a-select v-model="form.treeTimeId" >
          <a-select-option v-for="item in treeTimeList" :value="item.id">{{item.title}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="简述" prop="title" >
        <a-input v-model="form.title" placeholder="请输入简述" />
      </a-form-model-item>
      <a-form-model-item label="Banner" prop="banner" >
        <file-upload type="image" :defaultList="form.bannerArr" :count="1"
                     @input="getImg($event, 'banner')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="事件内容" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="时间点" prop="pointInTime" >
        <a-date-picker style="width: 100%" v-model="form.pointInTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="关联森林" prop="forestIds" >
        <a-select v-model="form.forestIds" mode="multiple">
          <a-select-option v-for="item in forestList" :value="item.id">{{item.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="关联树" prop="treeIds" >
        <a-select v-model="form.treeIds" mode="multiple">
          <a-select-option v-for="item in treeList" :value="item.id">{{item.title}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="关联文章" prop="articleIds" >
        <a-select v-model="form.articleIds" mode="multiple">
          <a-select-option v-for="item in articleList" :value="item.id">{{item.title}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getEvent, addEvent, updateEvent } from '@/api/tree/event'
import Editor from '@/components/Editor'
import {listTime} from "@/api/tree/time";
import {guid} from "@/utils/ruoyi";
import {listArticle} from "@/api/platform/article";
import {listForest} from "@/api/forest/forest";
import {listInfo} from "@/api/tree/info";
import moment from "moment";
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      treeTimeList:[],
      forestList:[],
      treeList:[],
      articleList:[],
      // 表单参数
      form: {
        id: null,
        treeTimeId: null,
        title: null,
        banner:null,
        bannerArr:[],
        bannerCount:1,
        content: null,
        pointInTime: null,
        forestIds: [],
        treeIds: [],
        articleIds:[],
        linkIds: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        treeTimeId: [
          { required: true, message: '时间树ID不能为空', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '简述不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '事件内容不能为空', trigger: 'blur' }
        ],
        pointInTime: [
          { required: true, message: '时间点不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.initTreeTime()
  },
  activated() {
    this.initTreeTime()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {

    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },

    initTreeTime(){
      listTime().then(res => {
        this.treeTimeList = res.data
      })
      listForest().then(res => {
        this.forestList = res.data
      })
      listArticle().then(res => {
        this.articleList = res.data
      })
      listInfo().then(res => {
        this.treeList = res.data
      })
    },

    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        treeTimeId: null,
        title: null,
        banner:null,
        bannerArr:[],
        bannerCount:1,
        content: null,
        pointInTime: null,
        forestIds: [],
        treeIds: [],
        articleIds:[],
        linkIds: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getEvent({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        let that = this;
        if(this.form.banner){
          this.form.bannerArr = []
          this.form.bannerArr.push({
            uid: guid(8, 10),
            name: that.form.banner,
            status: 'done',
            halfUrl: that.form.banner,
            url: that.form.banner,
            path: that.form.banner
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.form.pointInTime){
            this.form.pointInTime =  moment(this.form.pointInTime).format('YYYY-MM-DD HH:mm:ss')
          }
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateEvent(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addEvent(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
